import { render, staticRenderFns } from "./ITQ.vue?vue&type=template&id=3dae4b5c&scoped=true&lang=pug&"
import script from "./ITQ.vue?vue&type=script&lang=ts&"
export * from "./ITQ.vue?vue&type=script&lang=ts&"
import style0 from "./ITQ.vue?vue&type=style&index=0&id=3dae4b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae4b5c",
  null
  
)

export default component.exports